module.exports = function anonymous(it
/**/) {
var out='';var arr1=it;if(arr1){var item,index=-1,l1=arr1.length-1;while(index<l1){item=arr1[index+=1];out+=' <li data-filter-built data-value="'+(item.Value)+'" class="filter__item';if(item.Selected){out+=' is-current';}out+='" data-filter-item-option> <a href="#">';if(item.Text.split(' ')[0] === 'All'){out+=''+(item.Text.split(' ')[0])+' <span class="a11y">'+(item.Text.split(' ')[1])+'</span>';}else{out+=''+(item.Text);}out+='</a> </li>';} } return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/filterItemOption.dot
// module id = 246
// module chunks = 0 1